<template>
  <div class="permission-denied">
    <div class="permission-denied__content">
      <h1 class="permission-denied__title">We are sorry...</h1>
      <p class="permission-denied__description">
        The page you are trying to access is restricted. <br />
        Please refer to your system administrator
      </p>
      <a class="button cursor-pointer" @click="goBack()"> Re-Login</a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$store.dispatch("auth/logout", { vm: this }).then(() => {
        this.$router.push("/");
      });
    }
  }
};
</script>

<style>
.permission-denied {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  background: var(--canvas);
}
.permission-denied__title {
  font-size: var(--fs-display);
  font-weight: 600;
  text-align: center;
  color: var(--ink-900);
  letter-spacing: var(--tracking-tight);
  margin: 0 0 12px;
}
.permission-denied__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.permission-denied__description {
  text-align: center;
  font-size: var(--fs-body);
  line-height: 1.6;
  color: var(--muted);
  margin: 0 0 8px;
}
.permission-denied .button {
  background: var(--grad-accent);
  font-weight: 500;
  color: #fff;
  font-size: var(--fs-sm);
  text-decoration: none;
  border: none;
  padding: 0.6em 1.4em;
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm), inset 0 1px 0 rgba(255, 255, 255, 0.14);
  transition: filter var(--dur) var(--ease);
  cursor: pointer;
}

.permission-denied .button:hover {
  background: var(--grad-accent-hover);
}
</style>
